import { AVOID_DEACTIVATION_BANNER_HEIGHT as BANNER_HEIGHT } from '@atlassian/auto-upgrade-not-a-trial';

import { BANNER_NAME } from '../../constants.tsx';

import { useEnabledCriteria } from '../../services/use-enabled-criteria/index.tsx';

export const useBannerAutoUpgradeNotATrial = () => {
	const { isEnabled } = useEnabledCriteria();

	return { isEnabled, name: BANNER_NAME, height: isEnabled ? BANNER_HEIGHT : 0 };
};
